export default "__VITE_ASSET__BP4H1ryw__"